import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type ConnectedDeviceAcquiredJournalEvent from "./connected-device-acquired-journal-event";

//---- Automatically generated, don't update this part ----

/**
 * The creation of this JE will trigger the revocation of the device : https://developer.withings.com/developer-guide/v3/integration-guide/bulkship-cellular/get-access/terminatecellular/#tag/Glossary
 */
export default class ConnectedDeviceRevokedJournalEvent extends JournalEvent {
  static type = "connected-device-revoked-journal-event";

  /**
   * The date when the revocation will be effective
   */
  @attr("date") declare terminationDate: Date;

  /**
   * The mac address corresponding to the revoked device
   */
  @attr("string") declare macAddress: string;

  @belongsTo("connected-device-acquired-journal-event", {
    async: false,
    inverse: "connectedDeviceRevokedJournalEvent"
  })
  declare connectedDeviceAcquiredJournalEvent: ConnectedDeviceAcquiredJournalEvent;

  static validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.connected-device-revoked-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  get effectiveRevocationDate(): Date {
    return dayjs(this.occurredAt).add(30, "day").toDate();
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "connected-device-revoked-journal-event": ConnectedDeviceRevokedJournalEvent;
  }
}
